"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.list = exports.loadAsync = exports.save = void 0;
var cross_fetch_1 = __importDefault(require("cross-fetch"));
var voyageTestParams_sidecar_1 = require("@voyage/scene/voyageTestParams-sidecar");
var namespace = 'voyage-json-server';
// const filename = 'voyage'
var _dir = 'voyage-ships';
function save(filename, data, dir) {
    if (dir === void 0) { dir = _dir; }
    console.log(namespace, 'attempt to save', filename);
    cross_fetch_1.default('//localhost:4500/put', {
        method: 'POST',
        body: JSON.stringify({
            filename: filename,
            dir: dir,
            data: data,
        }, null, 2),
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(function (res) { })
        .catch(function (err) {
        console.error(namespace, err);
    });
}
exports.save = save;
// export function load() {
//   console.log(namespace, 'attempt to load', filename)
//   if (voyageTestParams.isDevMode) {
//     fetch('//localhost:4500/get', {
//       method: 'POST',
//       body: JSON.stringify(
//         {
//           filename,
//           dir,
//         },
//         null,
//         2,
//       ),
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     })
//       .then((res) => {
//         console.log('loaded')
//         res.json().then((res2) => {
//           //console.log(res2)
//         })
//       })
//       .catch((err) => {
//         console.error(namespace, err)
//       })
//   } else {
//   }
// }
function loadAsync(filename, dir) {
    if (dir === void 0) { dir = _dir; }
    return __awaiter(this, void 0, void 0, function () {
        var res, json, res, json, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log(namespace, 'attempt to load', filename);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    if (!voyageTestParams_sidecar_1.voyageTestParams.isDevMode) return [3 /*break*/, 4];
                    return [4 /*yield*/, cross_fetch_1.default('//localhost:4500/get', {
                            method: 'POST',
                            body: JSON.stringify({
                                filename: filename,
                                dir: dir,
                            }, null, 2),
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    json = _a.sent();
                    console.log(namespace, 'loaded');
                    return [2 /*return*/, json];
                case 4:
                    console.log('get raw json...');
                    return [4 /*yield*/, cross_fetch_1.default('assets/data/' + dir + '/' + filename + '.json', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 5:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 6:
                    json = _a.sent();
                    return [2 /*return*/, json
                        // TODO: fix this!
                        // return common.getPhaserScene().cache.json.get(filename)
                    ];
                case 7: return [3 /*break*/, 9];
                case 8:
                    err_1 = _a.sent();
                    console.error(namespace, err_1);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    });
}
exports.loadAsync = loadAsync;
// export async function loadSync(filename: string, dir = _dir) {
//   console.log(namespace, 'attempt to load', filename)
//   try {
//     console.log('get raw json...')
//     const res = await fetch('assets/data/' + dir + '/' + filename + '.json', {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     })
//     const json = await res.json()
//     return json
//     // TODO: fix this!
//     // return common.getPhaserScene().cache.json.get(filename)
//   } catch (err) {
//     console.error(namespace, err)
//   }
// }
function list(on) {
    console.log(namespace, 'listing');
    // _list = ['Loading...']
    cross_fetch_1.default('//localhost:4500/list', {
        method: 'POST',
        body: JSON.stringify({
            dir: _dir,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(function (res) {
        console.log('loaded');
        res.json().then(function (res2) {
            console.log(res2);
            on(res2);
        });
    })
        .catch(function (err) {
        console.error(namespace, err);
    });
}
exports.list = list;
